import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges, ViewChild, ElementRef, ViewChildren, QueryList, OnChanges } from '@angular/core';
import { SelectModel } from 'src/app/Components/sura-select/sura-select.model';
import { Month } from 'src/app/Models/MisViajes/months';

@Component({
  selector: 'app-sura-select-mis-viajes',
  templateUrl: './sura-select-mis-viajes.component.html',
  styleUrls: ['./sura-select-mis-viajes.component.css']
})
export class SuraSelectMisViajesComponent implements OnInit, OnChanges {

  selectedItem: any;

  @Input()
  elements: Month[];

  @Input()
  default: string;

  @Input()
  id: string;

  @Output()
  selected = new EventEmitter<Month>();

  status: boolean;

  selectedText: string;
  constructor() {
    this.selectedItem = 0;
    this.status = false;
    this.selectedText = this.default;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'elements') {
        if (this.elements.length > 0)
        {
          this.selectedItem = 0;
          this.selectedText = this.elements[0].name + ' ' + this.elements[0].year;
        }
      }
    }
  }

  onClickedOutside(e: Event): void {
    this.status = false;
  }

  onClickParent(): void {
    this.status = !this.status;
  }

  onKeyDown(e: KeyboardEvent): void {
  }

  onClickChild(value: Month, name: string): void {
    this.selectedItem = this.elements
      .findIndex(element =>
        element === value,
      );
    this.selected.emit(value);
    this.status = !this.status;
    this.selectedText = name;
  }

}
